import { PreferredTourFormat } from '../utilities/Enums';
import { AdditionalResident } from './Prospect';
import { httpRequest, Urls } from './Shared';

const PROSPECT_USER_PROFILE_URL = `${Urls.BASE_URL}/ProspectUserProfiles`;

export interface UpdateProspectUserProfile {
    firstName: string;
    lastName: string;
    email: string;
    contactPreference?: number;
}

export interface ProspectUserProfile extends UpdateProspectUserProfile {
    phone: string;
    prospectUserId: number;
}

export interface CreditCard {
    lastFourDigits: string;
    cardBrand: string;
    expirationDate: string;
}

export interface ProspectUserPreference {
    preferredTourFormat?: PreferredTourFormat;
    pet?: boolean;
    desiredMoveInDate?: string;
    desiredLeaseLength?: number;
    additionalResidents: AdditionalResident[];
}

export interface IdVerification {
    idVerified: boolean;
    idExpired: boolean;
}

export const getProspectUserProfile = () =>
    httpRequest<ProspectUserProfile>(PROSPECT_USER_PROFILE_URL, 'get');

export const updateProspectUserProfile = (profile: UpdateProspectUserProfile) =>
    httpRequest<boolean>(PROSPECT_USER_PROFILE_URL, 'put', profile);

export const getProspectUserPreferences = () =>
    httpRequest<ProspectUserPreference>(`${PROSPECT_USER_PROFILE_URL}/preferences`);

export const updateProspectUserPreferences = (preferences: ProspectUserPreference) =>
    httpRequest<boolean>(`${PROSPECT_USER_PROFILE_URL}/preferences`, 'put', preferences);

export const getPaymentMethod = () =>
    httpRequest<CreditCard>(`${PROSPECT_USER_PROFILE_URL}/payment`);

export const addPaymentMethod = (paymentToken: string) =>
    httpRequest<CreditCard>(`${PROSPECT_USER_PROFILE_URL}/payment`, 'post', {
        paymentToken
    });

export const updatePaymentMethod = (paymentToken: string) =>
    httpRequest<CreditCard>(`${PROSPECT_USER_PROFILE_URL}/payment`, 'put', {
        paymentToken
    });

export const getIdVerificationStatus = (idVerificationType: number) =>
    httpRequest<IdVerification>(
        `${PROSPECT_USER_PROFILE_URL}/${idVerificationType}/idVerification`
    );



// WEBPACK FOOTER //
// ./src/api/ProspectUserProfile.ts